import * as echarts from 'echarts';
import { z } from 'zod';
import { ProgressClockApp } from './ProgressClock/ProgressClockApp';

export class WidgetEngine<DT> {
    private _title: string;
    private _widgetName: string;
    private _defaultChartData: echarts.EChartsOption | null = null;
    private _dataSchema: z.Schema | null = null;
    public progressClock: ProgressClockApp = new ProgressClockApp(0);

    private _updateFunctionForChartData: (
        chartData: echarts.EChartsOption,
        data: DT
    ) => echarts.EChartsOption = () => {
        throw new Error('Update function for chart data is not set');
    };

    constructor(widgetName: string, title: string) {
        this._widgetName = widgetName;
        this._title = title;
    }

    setChartOption(chartOption: echarts.EChartsOption) {
        this._defaultChartData = chartOption;
    }

    setDataSchema(dataSchema: z.Schema) {
        this._dataSchema = dataSchema;
    }

    setUpdateFunction(
        updateFunction: (chartData: echarts.EChartsOption, data: DT) => echarts.EChartsOption
    ) {
        this._updateFunctionForChartData = updateFunction;
    }

    getDefaultChartData(): echarts.EChartsOption {
        return JSON.parse(JSON.stringify(this._defaultChartData));
    }

    getDataSchema(): z.Schema {
        if (this._dataSchema === null) {
            throw new Error('Data schema is not set');
        }
        return this._dataSchema;
    }

    callUpdateFunctionForChartData(data: DT): echarts.EChartsOption {
        try {
            data = this.getDataSchema().parse(data);
        } catch (error) {
            console.error('Data schema error:', error);
            return this.getDefaultChartData();
        }
        return this._updateFunctionForChartData(this.getDefaultChartData(), data);
    }

    getTitle() {
        return this._title;
    }

    getWidgetName() {
        return this._widgetName;
    }

    reload() {
        console.log('reload');
        this.progressClock.reset().callIntervalFunction(true);
    }
}
